"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var themeConfig = {
  color: {
    accent: "#4a90e2",
    accentHover: "#6eacf5",
    accentClicked: "#256fc5",
    accentHighlight: "#e9f3ff",
    accentDark: "#1156a6",
    accentBackground: "#f0f7ff",
    heading: "#222f42",
    backgroundPrimary: "#e8ebf1",
    backgroundSecondary: "#d2d5da",
    black1: "#223142",
    black2: "#707a85",
    black3: "#929fae",
    grey1: "#c5d0de",
    grey2: "#dfe6ee",
    grey3: "#eaf0f8",
    grey4: "#f2f6fc",
    white: "#fff",
    red: "#f85359",
    redHover: "#ff8084",
    redHighlight: "#fff0f0",
    redClicked: "#e32d34",
    redDark: "#cc1f25",
    redBackground: "#fff5f5",
    yellow: "#f29924",
    yellowHover: "#ffb24d",
    green: "#39b54a",
    greenHover: "#54d566",
    greenHighlight: "#e6fce9",
    greenClicked: "#198c29",
    greenDark: "#0a7319",
    greenBackground: "#f0fff2",
    orangeMedium: "#d97b00",
    orangeLight: "#fff1de",
    orangeBackground: "#fff8f0",
    dark: {
      // Primary Dark Palette
      uranus: "#070a0d",
      saturn: "#14181e",
      jupiter: "#181e26",
      mars: "#222933",
      earth: "#2c343f",
      venus: "#36404c",
      mercury: "#424c59",
      //Primary Colour Palette
      sapphire: "#1c62fd",
      amethyst: "#4780ff",
      ruby: "#ff4646",
      topaz: "#decd27",
      emerald: "#1cfda2",
      // Text & Icon Colour Palette
      iron: "#898989",
      copper: "#d0d0d0",
      silver: "#e3e3e3",
      zinc: "#686b6e",
      cobalt: "#999ca1",
      nickel: "#e3e3e3",
      // Extra Chart Colours
      marigold: "#ffaf5f",
      zinnia: "#4acfac",
      lavandula: "#7e8ce0",
      lavandulaDark: '#444ed4',
      dandelion: "#36c7d0",
      dandelionDark: "#1daec7",
      calendula: "#ffa48e",
      calendulaDark: "#ff8058",
      gardenia: "#ffdcb3",
      daffodil: "#96eb91",
      orchid: "#af43cb",
      white: "#fff",
      white0_06: "rgba(255, 255, 255, 0.06)",
      white0_12: "rgba(255, 255, 255, 0.12)",
      white0_18: "rgba(255, 255, 255, 0.18)",
      white0_1: "rgba(255, 255, 255, 0.1)",
      black0_1: "rgba(0, 0, 0, 0.1)",
      sapphireHover: "#3471fd",
      sapphireFocus: "#1958e3",
      disabledOpacity: 0.4
    }
  },
  staticColor: {
    learnerIndexActiveBg: "#515e71",
    learnerIndexBg: "#152338",
    learnerIndexLine: "#2b3848"
  },
  font: {
    // contentFont: "ProximaNova",
    contentFont: "ChronicaPro"
  },
  disabledOpacity: 0.5
}; // Currently separator is same as backgroundSecondary

themeConfig.color.separator = themeConfig.color.backgroundSecondary;
themeConfig.color.text = themeConfig.color.black1;
var _default = themeConfig;
exports["default"] = _default;